import { customizeError, formatDate, roundWithPrecision } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getSummaryInformation } from '../../services/seller'
import { getAuthOpenData, getOpenData } from '../../services/openData'

export const GET_SUMMARY_SECTION_INFORMATION = 'GET_SUMMARY_SECTION_INFORMATION'
export const GET_SUMMARY_SECTION_INFORMATION_ERROR = 'GET_SUMMARY_SECTION_INFORMATION_ERROR'
export const GET_SUMMARY_SECTION_INFORMATION_SUCCESS = 'GET_SUMMARY_SECTION_INFORMATION_SUCCESS'
export const GET_OPEN_DATA_INFORMATION = 'GET_OPEN_DATA_INFORMATION'
export const GET_OPEN_DATA_INFORMATION_ERROR = 'GET_OPEN_DATA_INFORMATION_ERROR'
export const GET_OPEN_DATA_INFORMATION_SUCCESS = 'GET_OPEN_DATA_INFORMATION_SUCCESS'
export const onGetOpenDataInformation = makeActionCreator(GET_OPEN_DATA_INFORMATION)
export const onGetOpenDataInformationError = makeActionCreator(GET_OPEN_DATA_INFORMATION_ERROR, 'payload')
export const onGetOpenDataInformationSuccess = makeActionCreator(GET_OPEN_DATA_INFORMATION_SUCCESS, 'payload')
export const onGetSummarySectionInformation = makeActionCreator(GET_SUMMARY_SECTION_INFORMATION)
export const onGetSummarySectionInformationError = makeActionCreator(GET_SUMMARY_SECTION_INFORMATION_ERROR, 'payload')
export const onGetSummarySectionInformationSuccess = makeActionCreator(
  GET_SUMMARY_SECTION_INFORMATION_SUCCESS,
  'payload'
)
export const onGetSummarySectionInformationThunk = payload => async dispatch => {
  dispatch(onGetSummarySectionInformation())

  try {
    const { data } = await getSummaryInformation({
      actionType: GET_SUMMARY_SECTION_INFORMATION,
      dni: payload.dni
    })

    return dispatch(
      onGetSummarySectionInformationSuccess({
        awardedAgreements: data?.payload?.convenios,
        contractualBehavior: {
          hasNoRate: data?.payload?.comportamientoContractual === -1,
          rate: data?.payload?.comportamientoContractual,
          max: 5,
          percentage: roundWithPrecision((data?.payload?.comportamientoContractual / 5) * 100.0, 1)
            .toString()
            .replace('.', ',')
        },
        error: undefined
      })
    )
  } catch (error) {
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        // A 403 error means that the token is public or that it's a seller trying to access information that it can not see
        reason = 'FORBIDDEN_ERROR'
        break
      case 404:
        reason = 'DNI_DOES_NOT_MATCH_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetSummarySectionInformationError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}

export const onGetOpenDataInformationThunk = payload => async dispatch => {
  dispatch(onGetOpenDataInformation())

  try {
    const { data: authOpenData } = await getAuthOpenData()
    const { data: openData } = await getOpenData({ dni: payload.dni, accessToken: authOpenData?.payload?.access_token })

    const currentLastDate = new Date(openData?.payload?.agno1?.toString(), `${openData?.payload?.nroMes1 - 1}`, '01')
    const currentNextDate = new Date(openData?.payload?.agno2?.toString(), `${openData?.payload?.nroMes2 - 1}`, '01')

    return dispatch(
      onGetOpenDataInformationSuccess({
        openData: openData?.payload,
        salesLastMonths: {
          amount: openData?.payload?.montoTotal || 0,
          period: `Periodo consultado ${formatDate(currentLastDate, 'MMMM yyyy').toLowerCase()} a ${formatDate(
            currentNextDate,
            'MMMM yyyy'
          ).toLowerCase()}`
        },
        error: undefined
      })
    )
  } catch (error) {
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      case 404:
        reason = 'DNI_DOES_NOT_MATCH_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetOpenDataInformationError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
